// extracted by mini-css-extract-plugin
module.exports = {"home":"Index_home__2jRhj"};